
import React from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import TravelSurveyPage from "./pages/TravelSurveyPage";
import AuthPage from "./pages/AuthPage";
import SignInPage from "./pages/SignInPage";
import ToolsSelectionPage from "./pages/ToolsSelectionPage";
import VisaTravelGuidesPage from "./pages/VisaTravelGuidesPage";
import VisaSponsoredJobsPage from "./pages/VisaSponsoredJobsPage";
import JobDetailsPage from "./pages/JobDetailsPage";
import BlogPage from "./pages/BlogPage";
import BlogPostUSA from "./pages/BlogPostUSA";
import BlogPostCanada from "./pages/BlogPostCanada";
import BlogPostUK from "./pages/BlogPostUK";
import BlogPostTopCountries from "./pages/BlogPostTopCountries";
import BlogPostNonTech from "./pages/BlogPostNonTech";
import BlogPostEmployerSponsorship from "./pages/BlogPostEmployerSponsorship";
import BlogPostMistakes from "./pages/BlogPostMistakes";
import BlogPostScholarshipTips from "./pages/BlogPostScholarshipTips";
import BlogPostScholarshipMistakes from "./pages/BlogPostScholarshipMistakes";
import BlogPostScholarshipProfile from "./pages/BlogPostScholarshipProfile";
import ScholarshipsPage from "./pages/ScholarshipsPage";
import ScholarshipDetailsPage from "./pages/ScholarshipDetailsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";

// Initialize the query client outside of the component
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipPrimitive.Provider>
        <Toaster />
        <Sonner />
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/visa-travel-guides" element={<VisaTravelGuidesPage />} />
              <Route path="/visa-sponsored-jobs" element={<VisaSponsoredJobsPage />} />
              <Route path="/job-details/:jobId" element={<JobDetailsPage />} />
              <Route path="/job/:jobId" element={<JobDetailsPage />} /> {/* Add this new route */}
              <Route path="/scholarships" element={<ScholarshipsPage />} />
              <Route path="/scholarship-details/:universityName" element={<ScholarshipDetailsPage />} />
              <Route path="/travel-survey" element={<TravelSurveyPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/sign-in" element={<SignInPage />} />
              <Route path="/tools" element={<ToolsSelectionPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/usa-visa-jobs" element={<BlogPostUSA />} />
              <Route path="/blog/canada-visa-jobs" element={<BlogPostCanada />} />
              <Route path="/blog/uk-visa-jobs" element={<BlogPostUK />} />
              <Route path="/blog/top-countries-visa-jobs" element={<BlogPostTopCountries />} />
              <Route path="/blog/non-tech-visa-jobs" element={<BlogPostNonTech />} />
              <Route path="/blog/employer-sponsorship" element={<BlogPostEmployerSponsorship />} />
              <Route path="/blog/common-mistakes" element={<BlogPostMistakes />} />
              <Route path="/blog/scholarship-tips" element={<BlogPostScholarshipTips />} />
              <Route path="/blog/scholarship-mistakes" element={<BlogPostScholarshipMistakes />} />
              <Route path="/blog/scholarship-profile" element={<BlogPostScholarshipProfile />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </TooltipPrimitive.Provider>
    </QueryClientProvider>
  );
}

export default App;
